import * as constants from './constants';
import * as slice from './slice';
import sagas from './saga';

const cashierService = { constants, ...slice, sagas };

export default cashierService;

